/**
 * Sets the `value` at the given `path.
 * It makes a copy of all the objects encountered along the way.
 * @param {string} key
 * @param {Object} message
 * @param {Object} [data={}]
 */
function createValidationElementReduxUtil (key, message, data = {}) {
  return {
    key,
    message,
    data
  }
}

export default createValidationElementReduxUtil
